export class AdminPath {
    constructor() {
        this.enabled = false;
        this.datacontainer = document.querySelector('html');
        this.adminPath = this.datacontainer.dataset.adminPath;

        if (this.datacontainer.dataset.adminPathEnabled) {
            this.enabled = true;
        }
    }
    url(path) {
        return path.replace(/^\/admin|^admin/i, this.adminPath);
    }
}